<template>
  <v-layout row wrap align-center v-on:keyup.enter="queryAllCourseInfo">
    <v-flex md3 align-self-center>
      <v-select
        v-model="select_semester"
        :items="semesters"
        item-text="Semester"
        item-value="Semester"
        :label="labels.semester"
      ></v-select>
    </v-flex>
    <v-flex md3>
      <v-text-field
        :label="labels.course_code"
        v-model="course_no"
      ></v-text-field>
    </v-flex>
    <v-flex md3>
      <v-text-field
        :label="labels.course_title"
        v-model="course_name"
      ></v-text-field>
    </v-flex>
    <v-flex md1 xs12>
      <v-btn
        round
        block
        :disabled="btn_state"
        v-on:click="queryAllCourseInfo()"
      >
        <v-icon>search</v-icon>
        {{ labels.search }}
      </v-btn>
    </v-flex>
    <v-flex md1 xs12>
      <v-btn round v-on:click="ExportExcel">{{ labels.save_excel }}</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import XLSX from "xlsx";
import languages from "../../languages/TabOldCourse.json";
import excel_languages from "../../languages/Excel.json";

export default {
  data: () => ({
    labels: {
      semester: "",
      course_code: "",
      course_title: "",
      search: "",
      save_excel: "",
    },
    selectDepartment: "",
    course_no: "",
    course_name: "",
  }),
  computed: {
    btn_state() {
      return this.$store.state.btn_state;
    },
    departments() {
      return this.$store.state.departments;
    },
    semesters() {
      return this.$store.state.semesters;
    },
    select_semester: {
      get() {
        return this.$store.state.select_semester;
      },
      set(value) {
        this.$store.commit("setSelectSemester", value);
      },
    },
    select_language() {
      return this.$store.state.select_language;
    },
  },
  watch: {
    select_language(value) {
      this.setLanguage(value);
    },
  },
  created() {
    this.setLanguage(this.$store.state.select_language);
  },
  methods: {
    queryAllCourseInfo: function() {
      if (this.select_semester == "") {
        this.$store.commit("showAlert", "請選擇學期!");
      } else {
        var query_params = {
          Semester: this.select_semester,
          CourseNo: this.course_no,
          CourseName: this.course_name,
          CourseTeacher: "",
          Dimension: "",
          CourseNotes: "",
          ForeignLanguage: 0,
          OnlyGeneral: 0,
          OnleyNTUST: 0,
          OnlyMaster: 0,
          OnlyUnderGraduate: 0,
          OnlyNode: 0,
          OldCourse: true,
          Language: this.select_language.lang,
        };
        this.$store.dispatch("queryCourseInfo", query_params);
      }
    },
    ExportExcel: function() {
      var info_data = JSON.parse(JSON.stringify(this.$store.state.info));
      info_data.forEach((element) => {
        element[
          excel_languages.course_code[this.$store.state.select_language.lang]
        ] = element["CourseNo"];
        element[
          excel_languages.course_title[this.$store.state.select_language.lang]
        ] = element["CourseName"];
        element[
          excel_languages.instructor[this.$store.state.select_language.lang]
        ] = element["CourseTeacher"];
        element[
          excel_languages.ge_type[this.$store.state.select_language.lang]
        ] = element["Dimension"];
        element[
          excel_languages.credits[this.$store.state.select_language.lang]
        ] = element["CreditPoint"];
        element[
          excel_languages.required_elective[
            this.$store.state.select_language.lang
          ]
        ] = element["RequireOption"];
        element[
          excel_languages.full_half[this.$store.state.select_language.lang]
        ] = element["AllYear"];
        element[
          excel_languages.ntust_student_registered[
            this.$store.state.select_language.lang
          ]
        ] = element["ChooseStudent"];
        element[
          excel_languages.ntu_system_student_registered[
            this.$store.state.select_language.lang
          ]
        ] = element["ThreeStudent"];
        element[
          excel_languages.total_registered[
            this.$store.state.select_language.lang
          ]
        ] = element["AllStudent"];
        element[
          excel_languages.maxi_capacity_for_ntust_preregistration[
            this.$store.state.select_language.lang
          ]
        ] = element["Restrict1"];
        element[
          excel_languages.maxi_capacity_for_ntust_add_drop[
            this.$store.state.select_language.lang
          ]
        ] = element["Restrict2"];
        element[
          excel_languages.ntu_quota[this.$store.state.select_language.lang]
        ] = element["NTURestrict"];
        element[
          excel_languages.ntnu_quota[this.$store.state.select_language.lang]
        ] = element["NTNURestrict"];
        element[
          excel_languages.lecture_hours[this.$store.state.select_language.lang]
        ] = element["CourseTimes"];
        element[
          excel_languages.intern_hours[this.$store.state.select_language.lang]
        ] = element["PracticalTimes"];
        element[
          excel_languages.location[this.$store.state.select_language.lang]
        ] = element["ClassRoomNo"];
        element[excel_languages.time[this.$store.state.select_language.lang]] =
          element["Node"];
        element[excel_languages.notes[this.$store.state.select_language.lang]] =
          element["Contents"];

        delete element["total_students"];
        delete element["Semester"];
        delete element["CourseNo"];
        delete element["CourseName"];
        delete element["CourseTeacher"];
        delete element["Dimension"];
        delete element["CreditPoint"];
        delete element["RequireOption"];
        delete element["AllYear"];
        delete element["ChooseStudent"];
        delete element["ThreeStudent"];
        delete element["AllStudent"];
        delete element["Restrict1"];
        delete element["Restrict2"];
        delete element["NTURestrict"];
        delete element["NTNURestrict"];
        delete element["CourseTimes"];
        delete element["PracticalTimes"];
        delete element["ClassRoomNo"];
        delete element["Node"];
        delete element["Contents"];
        delete element["disable"];
        delete element["ThreeNode"];
      });
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet(info_data);
      XLSX.utils.book_append_sheet(wb, ws, "sheet1");
      XLSX.writeFile(wb, "out.xlsx");
    },
    setLanguage: function(select_language) {
      this.labels.semester = languages.semester[select_language.lang];
      this.labels.course_code = languages.course_code[select_language.lang];
      this.labels.course_title = languages.course_title[select_language.lang];
      this.labels.search = languages.search[select_language.lang];
      this.labels.save_excel = languages.save_excel[select_language.lang];
    },
  },
};
</script>
